import React, { Component } from "react";
import { Editor } from "@tinymce/tinymce-react";
import style from "./BlogEditor.module.scss";

class BlogEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 0,
    };
  }

  handleTabChange = (index) => {
    this.setState({ selected: index });
  };

  renderEditor = () => {
    const {
      toggleList,
      onToggle,
      onChangeRawHtMl,
      rawHtml,
      emailText,
      onChange,
      buttonHtml,
    } = this.props;

    return (
      <div className={style.panel}>
        <div className={style.toolbar}>
          <div className={style.toolbarLeft}>
            <p className={style.toolbarTitle}>
              {toggleList ? "Raw HTML mode" : "Visual editor"}
            </p>
            <p className={style.toolbarHint}>
              Write the blog body. Switch to preview anytime to check layout.
            </p>
          </div>

          <div className={style.modeToggle}>
            <p className={style.modeLabel}>
              {toggleList ? "Raw HTML" : "Editor"}
            </p>
            <label className={style.switch}>
              <input
                type="checkbox"
                checked={toggleList}
                onChange={onToggle}
              />
              <span className={style.slider} />
            </label>
          </div>
        </div>

        {toggleList ? (
          <textarea
            className={style.rawArea}
            value={rawHtml}
            onChange={(e) => onChangeRawHtMl(e)}
            placeholder="Paste or edit raw HTML here…"
            rows={20}
            name="comment[text]"
            id="comment_text"
            cols={40}
            autoComplete="off"
          />
        ) : (
          <div className={style.editorWrap}>
            <Editor
              value={emailText}
              init={{
                height: 580,
                statusbar: false,
                menubar: false,
                plugins: ["link image code", "textcolor", "lists"],
                placeholder: "Start writing your blog content…",
                toolbar:
                  "undo redo | styleselect | bold italic underline | forecolor backcolor | bullist numlist | alignleft aligncenter alignright | link image | code | currentdate",
                content_style:
                  "body { font-family: Segoe UI, system-ui, sans-serif; font-size: 15px; line-height: 1.6; color: #1a2332; padding: 12px; } p { margin: 0 0 12px; }",
                setup: function (editor) {
                  function insertBtn() {
                    editor.insertContent(buttonHtml || "");
                  }

                  editor.ui.registry.addButton("currentdate", {
                    text: "Insert Button",
                    tooltip: "Insert Button",
                    onAction: () => insertBtn(),
                  });
                },
              }}
              onEditorChange={(e) => onChange(e, "main-editor")}
              id="blog-editor"
            />
          </div>
        )}
      </div>
    );
  };

  renderPreview = () => {
    const { footerRender } = this.props;
    const hasPreview = Boolean(footerRender && footerRender.trim());

    return (
      <div className={style.panel}>
        <div className={style.toolbar}>
          <div className={style.toolbarLeft}>
            <p className={style.toolbarTitle}>Live preview</p>
            <p className={style.toolbarHint}>
              How the published blog content will look.
            </p>
          </div>
        </div>

        {hasPreview ? (
          <div className={style.editorWrap}>
            <iframe
              className={style.previewFrame}
              title="Blog preview"
              srcDoc={footerRender}
            />
          </div>
        ) : (
          <div className={style.previewEmpty}>
            <p className={style.previewEmptyTitle}>Nothing to preview yet</p>
            <p className={style.previewEmptyHint}>
              Start writing in the Blog Content tab. Your preview will show up
              here.
            </p>
          </div>
        )}
      </div>
    );
  };

  render() {
    const { selected } = this.state;
    const tabs = [
      { title: "Blog Content", render: this.renderEditor },
      { title: "Preview", render: this.renderPreview },
    ];

    return (
      <div className={style.shell}>
        <header className={style.header}>
          <p className={style.eyebrow}>Editor · Preview</p>
          <h2 className={style.title}>Write & review</h2>
          <p className={style.subtitle}>
            Compose the article here, then check Preview before you publish.
          </p>
        </header>

        <div className={style.card}>
          <div className={style.tabs} role="tablist">
            {tabs.map((tab, index) => (
              <button
                key={tab.title}
                type="button"
                role="tab"
                aria-selected={selected === index}
                className={`${style.tabBtn} ${
                  selected === index ? style.tabBtnActive : ""
                }`}
                onClick={() => this.handleTabChange(index)}
              >
                {tab.title}
              </button>
            ))}
          </div>
          {tabs[selected].render()}
        </div>
      </div>
    );
  }
}

export default BlogEditor;
